import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpSentEvent, HttpHeaderResponse, HttpProgressEvent, HttpResponse, HttpUserEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MsalService } from '@azure/msal-angular';
import { AuthenticationResult } from '@azure/msal-browser';

@Injectable({
  providedIn: 'root'
})
export class HttpInterceptorService implements HttpInterceptor {
  sessionExpiredShown = false;
  azureAuthFlag: boolean = false;
  appDetails;
  constructor(private router: Router, private toastr: ToastrService, private msalService: MsalService) {
    if (sessionStorage.hasOwnProperty('appconfig'))
      this.appDetails = JSON.parse(sessionStorage.getItem('appconfig') || '{}');
  }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpSentEvent | HttpHeaderResponse | HttpProgressEvent | HttpResponse<any> | HttpUserEvent<any> | any> {
    const started = Date.now();
    let tokenType = sessionStorage.getItem('customToken') === null ? sessionStorage.getItem('accessToken') : sessionStorage.getItem('customToken');
    if (tokenType) {
      const clonedreq = req.clone({
        headers: req.headers.set(
          'Authorization',
          `Bearer ${tokenType}`
        ).append('userId', `${sessionStorage.getItem('userId')}`).append('Access-Control-Allow-Origin', 'tce-project.tcsappsdev.com')
          .append('Cache-Control', 'no-cache, no-store, must-revalidate, post-check=0, pre-check=0')
          .append('X-XSS-Protection', '1; mode=block')
          .append("X-Frame-Options", "deny")
          .append('Content-Security-Policy', 'frame-ancestors "self"')
      })

      //update activity on every API call
      sessionStorage.setItem('lastActivityTime', Date.now().toString()); ``
      return next.handle(clonedreq).pipe(tap(event => {
        const elapsed = Date.now() - started;
        if (event instanceof HttpResponse) {
        };
      }), catchError(err => {
        if (err instanceof HttpErrorResponse) {
          if (err.status === 401) {
            if (err.error?.error === 'Unauthorized') {
              if (!this.sessionExpiredShown) {
                this.sessionExpiredShown = true;
                this.toastr.error(
                  'Session expired. Please login again.',
                  'Unauthorized',
                  {
                    timeOut: 5000,
                    closeButton: true,
                    progressBar: true
                  }
                );
              
                this.msalService.instance.setActiveAccount(null);
                sessionStorage.removeItem('accessToken');
                sessionStorage.removeItem('customToken');
                sessionStorage.removeItem('userId');
                sessionStorage.removeItem('userName');
                sessionStorage.removeItem('lastActivityTime');
                setTimeout(() => {

                  this.azureAuthFlag = (this.appDetails['azureAuthFlag'] != undefined) ? this.appDetails['azureAuthFlag'] : false;
                  if (this.azureAuthFlag) {
                    window.location.href = window.location.origin + '/'
                  } else {
                    this.router.navigateByUrl('/login');
                  }
                }, 2000)
              }

            }
          }
        }

        return of(err);
      }));
    }
    else if (sessionStorage.getItem('userId')) {
      req = req.clone({
        setHeaders: { userId: sessionStorage.getItem('userId') }
      });
    } else {
      req = req.clone({
        setHeaders: { userId: "admin@tcs.com" }
      });
    }
    return next.handle(req);
  }
 
}